<img
  [src]="'/assets/images/icons/flags/' + language.locale + '.svg' | ssrEmptyString"
  [alt]="language.label"
  class="flag"
  *ngIf="language"
  corporateImageLazyLoad
/>
